export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_48-6dabccae1e46e1e23eff1b7a6c0e95cb.jpg";